// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconFooterPhone = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                d="M0,1.25 L5.625,0 L8.75,5.625 L5.47656238,8.2421875 C6.88671827,10.9140623 9.08203125,13.1093752 11.7578125,14.523437 L14.375,11.25 L20,14.375 L18.75,20 L17.5,20 C7.83593774,20 0,12.1640623 0,2.5 L0,1.25 Z"
            />
        </svg>
    );
};

export default React.memo(IconFooterPhone);
